<po-page-default p-title="Pendência estadual" [p-breadcrumb]="breadcrumb">
  <div class="analise-intro po-mb-3">
    <span class="analise-intro-titulo po-font-text-uppercase">
      <span class="an an-scales"></span>
      Pendência estadual
    </span>

    <div class="destaque po-mt-2">
      <p class="po-font-text-large po-mb-1">
        A <b>pendência estadual</b> é a consulta de débitos tributários do Estado de São Paulo
        vinculados ao CNPJ da empresa. Nesta tela você acompanha os arquivos já emitidos,
        filtra pelas tags de análise e gera relatório.
      </p>
      <p class="po-mb-1">
        Essa consulta é retirada de <b>dois portais oficiais</b>, conforme o tipo de dívida:
      </p>
      <p>
        <b>&nbsp;&nbsp; - Dívida inscrita:</b>
        <a href="https://www.dividaativa.pge.sp.gov.br/sc/pages/consultas/consultarDebito.jsf" target="_blank" rel="noopener noreferrer">
          PGE-SP Dívida Ativa
        </a>
        (consulta de débitos inscritos).
      </p>
      <p>
        <b>&nbsp;&nbsp; - Dívida não inscrita:</b>
        <a href="https://www3.fazenda.sp.gov.br/CAWEB/Account/Login.aspx" target="_blank" rel="noopener noreferrer">
          SEFAZ-SP / CAWEB
        </a>
        (consulta de pendências não inscritas).
      </p>
      <p class="po-mb-0 po-mt-2">
        Use <b>Consulta de pendência</b> para solicitar uma nova consulta por empresa ou planilha de CNPJs.
      </p>
    </div>
  </div>

  <div class="analise-page-actions">
    <div class="analise-page-actions-left">
      <div class="analise-tipo-toggle" role="group" aria-label="Tipo de pendência">
        <po-button
          p-label="Inscrita"
          [p-kind]="tipoAnalise === 'inscrita' ? 'primary' : 'secondary'"
          [p-disabled]="carregando || loadingShowMore"
          (p-click)="selecionarTipoAnalise('inscrita')">
        </po-button>
        <po-button
          p-label="Não inscrita"
          [p-kind]="tipoAnalise === 'nao-inscrita' ? 'primary' : 'secondary'"
          [p-disabled]="carregando || loadingShowMore"
          (p-click)="selecionarTipoAnalise('nao-inscrita')">
        </po-button>
      </div>
      <po-button
        p-label="Relatório"
        p-kind="secondary"
        p-icon="an an-file-arrow-down"
        (p-click)="abrirRelatorioPendencias()">
      </po-button>
      <po-button
        p-label="Atualizar"
        p-kind="secondary"
        p-icon="an an-arrows-clockwise"
        [p-loading]="carregando"
        [p-disabled]="carregando || loadingShowMore"
        (p-click)="loadMore(true)">
      </po-button>
    </div>
    <po-button
      class="analise-page-actions-right"
      p-label="Consulta de pendência"
      p-kind="primary"
      p-icon="an an-robot"
      (p-click)="irConsultaPendencia()">
    </po-button>
  </div>

  <div class="analise-filtros" *ngIf="possuiFiltrosTags">
    <p class="analise-filtros-titulo">
      <ng-container *ngIf="processos.length > 0; else tagsSemLista">
        {{ processos.length }} documento(s) carregado(s) — <b>{{ itensFiltrados.length }}</b> exibido(s)
        <span *ngIf="moreItens"> — use <b>Carregar mais</b> para ampliar</span>
      </ng-container>
      <ng-template #tagsSemLista>
        Tags oficiais disponíveis para filtro e relatório.
      </ng-template>
    </p>
    <div class="analise-filtros-botoes">
      <button
        *ngFor="let tagFiltro of tagsFiltro"
        type="button"
        class="filtro-chip"
        [class.filtro-ativo]="filtroTagAtivo(tagFiltro.tag)"
        [ngStyle]="estiloChip(tagFiltro)"
        (click)="alternarFiltroTag(tagFiltro.tag)">
        {{ tagFiltro.label }} ({{ tagFiltro.count }})
      </button>
    </div>
  </div>

  <po-table
    p-container="border"
    class="analise-table po-mt-2"
    p-striped="true"
    p-text-wrap="true"
    p-hide-columns-manager="true"
    [p-columns]="columns"
    [p-items]="itensFiltrados"
    [p-loading]="carregando"
    [p-actions]="tableActions"
    (p-show-more)="loadMore()"
    [p-show-more-disabled]="!moreItens"
    [p-loading-show-more]="loadingShowMore">
    <ng-template p-table-column-template [p-property]="'tags'" let-value>
      <ng-container *ngIf="tagsParaBadges(value) as badges">
        <ng-container *ngIf="badges.length > 0; else semTags">
          <span
            *ngFor="let badge of badges"
            class="tag-badge"
            [ngStyle]="estiloChip(badge)">
            {{ badge.label }}
          </span>
        </ng-container>
      </ng-container>
      <ng-template #semTags>—</ng-template>
    </ng-template>
  </po-table>

  <div class="analise-vazio" *ngIf="!carregando && processos.length === 0">
    {{ mensagemListaVazia }}
    Clique em <b>Atualizar</b> para recarregar a lista.
  </div>
</po-page-default>

<po-modal
  #modalRelatorioPendencias
  p-size="md"
  p-title="Relatório de Pendências"
  p-icon="an an-file-arrow-down"
  p-click-out="false"
  (p-close)="fecharRelatorioPendencias()">
  <div class="modal-relatorio-pendencias">
      <p class="modal-relatorio-hint">
        O relatório é gerado no servidor (competência + tags do tipo selecionado)
        e baixa um único ZIP com CSV índice e os PDFs.
      </p>

    <po-select
      class="po-lg-12"
      p-label="Competência"
      p-placeholder="Selecione mês e ano"
      p-name="competenciaRelatorio"
      [p-show-required]="true"
      [p-required]="true"
      (p-change)="onChangeCompetenciaRelatorio($event)"
      [p-options]="competenciaRelatorioOptions"
      p-help="Ex.: 05-2026">
    </po-select>

    <p class="modal-relatorio-preview po-mt-2" *ngIf="competenciaRelatorio">
      A quantidade exata será calculada ao gerar o relatório, considerando todos os documentos.
    </p>

    <div class="modal-relatorio-tags" *ngIf="possuiFiltrosTags">
      <p class="modal-relatorio-tags-titulo">Filtrar por tags</p>
      <p class="modal-relatorio-tags-hint">
        Lista oficial de tags, independente dos arquivos já carregados na paginação.
        Os números entre parênteses refletem só a listagem atual.
      </p>
      <div class="analise-filtros-botoes">
        <button
          *ngFor="let tagFiltro of tagsFiltro"
          type="button"
          class="filtro-chip"
          [class.filtro-ativo]="filtroTagAtivo(tagFiltro.tag)"
          [ngStyle]="estiloChip(tagFiltro)"
          (click)="alternarFiltroTag(tagFiltro.tag)">
          {{ tagFiltro.label }} ({{ tagFiltro.count }})
        </button>
      </div>
    </div>
  </div>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="fecharRelatorioPendencias()"></po-button>
    <po-button
      p-label="Gerar relatório"
      p-icon="an an-file-arrow-down"
      [p-loading]="loadingRelatorioPendencias"
      (p-click)="gerarRelatorioPendencias()">
    </po-button>
  </po-modal-footer>
</po-modal>
